import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { deleteRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/DynamicFieldsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

type DeleteDynamicFieldOptionProps = {
  dynamicFieldUuid: string;
  optionUuid: string;
};

const deleteDynamicFieldOption = async ({
  dynamicFieldUuid,
  optionUuid,
}: DeleteDynamicFieldOptionProps) => {
  const { data } = await deleteRequest<RequestSimplifiedData>(
    API.DELETE.deleteDynamicFieldOption(dynamicFieldUuid, optionUuid),
  );
  return data;
};

export const useDeleteDynamicFieldOption = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteDynamicFieldOption,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.dynamicOptionDeleted), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.DYNAMIC_FIELDS] });
    },
    onError: handleError,
  });
};
